"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseVersions = void 0;
//@ts-nocheck
exports.caseVersions = [
    {
        processInstanceCreatedDate: 1688074858,
        processInstanceGuid: "string",
        processInstanceStatus: "REPLACED",
        sourceCaseId: 8080
    },
    {
        processInstanceCreatedDate: 1688074858,
        processInstanceGuid: "string",
        processInstanceStatus: "NEW",
        sourceCaseId: 8080
    }
];
//# sourceMappingURL=case-version.js.map